import {
  LayoutDashboard,
  Building2,
  Calendar,
  CheckSquare,
  FolderLock,
  Briefcase,
  BarChart3,
  LifeBuoy,
} from 'lucide-react';

export const STARTUP_NAV = [
  { path: '/startup-dashboard', label: 'Overview', icon: LayoutDashboard, end: true },
  { path: '/startup-dashboard/profile', label: 'Startup Profile', icon: Building2 },
  { path: '/startup-dashboard/vault', label: 'Documents', icon: FolderLock, badge: '1' },
  { path: '/startup-dashboard/tasks', label: 'Roadmap & Tasks', icon: CheckSquare, badge: '5' },
  { path: '/startup-dashboard/calendar', label: 'Calendar', icon: Calendar, badge: '2' },
  { path: '/startup-dashboard/investor-readiness', label: 'Investor Readiness', icon: Briefcase },
  { path: '/startup-dashboard/metrics', label: 'Growth & Metrics', icon: BarChart3 },
  { path: '/startup-dashboard/support', label: 'Resources & Settings', icon: LifeBuoy },
];

export const STARTUP_TITLES = {
  '/startup-dashboard': 'Overview',
  '/startup-dashboard/profile': 'Startup Profile',
  '/startup-dashboard/vault': 'Documents',
  '/startup-dashboard/tasks': 'Roadmap & Tasks',
  '/startup-dashboard/calendar': 'Calendar',
  '/startup-dashboard/investor-readiness': 'Investor Readiness',
  '/startup-dashboard/metrics': 'Growth & Metrics',
  '/startup-dashboard/support': 'Resources & Settings',
};
